import React, { useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import { Link } from 'react-router-dom'
import { formatDate } from '../../utils/helpers';
import axiosInstance from '../../utils/api';

type Props = {}

const AppBoardPassed = (props: Props) => {
    const title = "App Board Passed"
    const [loading, setLoading] = useState(false)
    const [appBoardPassed, setAppBoardPassed] = useState<any>([])
    const [testDetailModal, setTestDetailModal] = useState(false)
    const [selectedTestDetail, setSelectedTestDetail] = useState({
        title: "",
        content: ""
    })
    const [somList, setSomList] = useState<any>([])
    const [somListModal, setSomListModal] = useState(false)

    useEffect(() => {
        getData()
    }, [])

    function getData() {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1.0/pcba/application").then(res=>{
            setLoading(false)
            console.log(11, res.data)
            setAppBoardPassed(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return
    }
    return (
                
        <div className="col-12">
            {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                    <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                        <h5 className="card-title">{title} List</h5>
                        <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                            
                            <Link to="/pcba/add" >
                                <button type="button" className="btn btn-outline-info">Create</button>
                            </Link>
                        </div>

                    </div>

                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Datetime</th>
                                    <th scope="col">App Board Serial</th>
                                    <th scope="col">Som List</th>
                                    <th scope="col">Is Used</th>
                                    <th scope="col">Remark</th>
                                    <th scope="col">Test Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appBoardPassed.map( (som:any, index:number) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{formatDate(som.datetime)}</th>
                                            <td>{som.app_board_serial}</td>
                                            {(som.som && som.som.length > 0) ? (
                                            <td>
                                            <button type="button" className="btn btn-outline-info" onClick={()=>{
                                                for (let s of som.som) {
                                                    setSomList( [...somList, s.mcuid])
                                                }
                                                setSomListModal(true)
                                            }}>Show</button>
                                            </td>
                                            ) : (
                                                <td></td>
                                            )}
                                            <td>{som.is_used}</td>
                                            <td>{som.remark}</td>
                                            {som.test_details ? (
                                            <td>
                                            <button type="button" className="btn btn-outline-info" onClick={()=>{
                                                setSelectedTestDetail({
                                                    title: som.package.name.name,
                                                    content: som.test_details
                                                })
                                                setTestDetailModal(true)
                                            }}>Show</button>
                                            </td>
                                            ) : (
                                                <td></td>
                                            )}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            <div className="modal fade show" style={(testDetailModal || somListModal) ? {display:'block'} : {display: 'none'}}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLongTitle">{testDetailModal ? selectedTestDetail.title : "Som List"}</h5>
                    </div>
                    <div className="modal-body">
                        {somListModal && (
                            <>
                            {somList.map((som:any) => {
                                return (
                                    <p>{som}</p>
                                )
                            })}
                            </>
                        )}
                        
                        {testDetailModal && (
                            <>
                            { selectedTestDetail.content}
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={()=>{
                            setTestDetailModal(false)
                            setSomListModal(false)
                        }}>Close</button>
                    </div>
                    </div>
                </div>
            </div>

        </div>

    )
}

export default AppBoardPassed